const NO_RESULTS_CLASS = 'no-results';

class JobList {
  constructor(el) {
    this.el = el;
    this.filters = el.querySelectorAll('select[data-filter]');
    this.jobGrid = el.querySelector('.js-job-grid');
    this.jobs = el.querySelectorAll('.js-job');

    this.activeFilters = {};

    if (!this.jobGrid) {
      console.warn('No job grid found.');
      return;
    }

    this.setupListeners();
  }

  setupListeners() {
    this.filters.forEach(select => select.addEventListener('change', this.handleChange.bind(this)));
  }

  handleChange(event) {
    const filter = event.target.dataset.filter;
    const value = event.target.value;

    if (value) {
      this.activeFilters[filter] = value;
    } else {
      delete this.activeFilters[filter];
    }

    this.transitionContent();
  }

  transitionContent() {
    let activeJobs = 0;

    this.jobs.forEach(job => {
      const active = Object.keys(this.activeFilters).every(
        filter => job.dataset[filter] === this.activeFilters[filter],
      );

      if (active) {
        activeJobs += 1;
        job.removeAttribute('style');
      } else {
        job.style.display = 'none';
      }
    });

    if (activeJobs === 0) {
      this.jobGrid.classList.add(NO_RESULTS_CLASS);
    } else {
      this.jobGrid.classList.remove(NO_RESULTS_CLASS);
    }
  }
}

export default JobList;
